import {
    AddSVG,
    BinSVG,
    ChevronSVG,
    CrossSVG,
    PadlockSVG,
    SearchSVG,
    UsersSVG,
    LeftArrow,
    RightArrow,
    Help,
} from '../../components/common/icons';

export const icons = {
    add: AddSVG,
    bin: BinSVG,
    chevron: ChevronSVG,
    cross: CrossSVG,
    padlock: PadlockSVG,
    search: SearchSVG,
    users: UsersSVG,
    leftArrow: LeftArrow,
    rightArrow: RightArrow,
    help: Help,
};

const IconComponent = ({ className, colour, height, icon, onClick, title, width, rotate = 0 }) => {
    const Icon = icons[icon];
    return (
        <span
            className={`${className} ${onClick ? 'cursor-pointer' : ''}`}
            onClick={onClick}
            title={title}
        >
            <Icon colour={colour} height={height} width={width} rotate={rotate} />
        </span>
    );
};

export default IconComponent;
